import React, { useState, useEffect, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import DefaultLayout from '../layouts/DefaultLayout';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router';
import { Col, Container, Image, Row } from 'react-bootstrap';
import clsx from 'clsx';
import Iframe from 'react-iframe';
import { getStaticPage } from '../services/staticPageService';
import Text from '../components/Text';
import BaseFooter from './BaseFooter';


export interface AboutUsProps {
  history: any
}

const AboutUs: React.FC<AboutUsProps> = ({ history }) => {
  const classes = useStyles();
  const [html, setHtml] = useState<string>("");
  const [title, setTitle] = useState<string>();

  useEffect(() => {
    (async () => {
      let { title, value } = await getStaticPage("AboutUs")
      setHtml(value)
      setTitle(title)
    })();
  }, []);

  return (
    <>
      <Helmet>
        <title>twigBIG</title>
      </Helmet>

      <DefaultLayout history={history}>
        <Container className={clsx(classes.container, 'mt-5')} fluid>
          <Row>
            <Col xs={12} style={{ textAlign: "center" }}>
              <Image width="200px" src={`${process.env.PUBLIC_URL}/assets/img/twigLogo.svg`}>
              </Image>

              <Text className={classes.title} as="p">
                {title}
              </Text>
            </Col>

            <Col xs={12} dangerouslySetInnerHTML={{ __html: html }}>
            </Col>
          </Row>
        </Container>
        <BaseFooter></BaseFooter>
      </DefaultLayout>
    </>
  );
};

const useStyles = createUseStyles({
  container: {
    maxWidth: '85vw',
  },
  '@media (max-width: 768px)': {
    container: {
      maxWidth: '850vw',
    }
  },
  title: {
    fontSize: "25px",
    fontWeight: "bold",
    margin: "10px 0px 20px !important"
  }
});

export default AboutUs;
